import { PriceBreakUpItem } from '@/src/types/fareFamilyInfo'
import { useTranslations } from 'next-intl'
import { useMemo, useState } from 'react'
import Timeline from './timeline'

interface TimelineWrapperProps {
    type: 'CANCEL' | 'AMEND'
    timeSegments: string[]
    priceSegments: { priceValue: string; priceBreakUp: PriceBreakUpItem[] }[]
    segmentCount: number
    isParentOpen?: boolean
}

const TimelineWrapper = ({
    type,
    timeSegments,
    priceSegments,
    segmentCount,
    isParentOpen = true
}: TimelineWrapperProps) => {
    const [tooltipOpen, setTooltipOpen] = useState(false)
    const t = useTranslations('itineraryPage.transparencyWidget')

    const title = type === 'CANCEL' ? t('amountRefundable') : t('dateChangeCharges')
    const blockTitle = type === 'CANCEL' ? t('cancelBetween') : t('changeBetween')

    const timeLineColorMap = useMemo(() => {
        const colors = ['success.main', 'success.main', 'warning.main', 'error.main']
        colors.splice(0, 4 - segmentCount)
        return colors
    }, [segmentCount])

    return (
        <Timeline
            timeSegments={timeSegments}
            priceSegments={priceSegments}
            segmentCount={segmentCount}
            title={title}
            blockTitle={blockTitle}
            timeLineColorMap={timeLineColorMap}
            tooltipOpen={tooltipOpen && isParentOpen}
            setTooltipOpen={setTooltipOpen}
        />
    )
}

export default TimelineWrapper
